<template>
  <v-autocomplete
    label="Rombel"
    :value="value"
    @change="handleChange"
    placeholder="Pilih Rombel"
    :items="rombel"
  >
  </v-autocomplete>
</template>

<script>
export default {
  data() {
    return {
      rombel: [],
    };
  },
  mounted() {
    this.getData();
  },
  props: ["value"],
  emits: ["change"],
  methods: {
    getData() {
      this.$root.app.http.get("/api/rombel").then((res) => {
        res.data.forEach((item) => {
          this.rombel.push({
            value: item.id,
            text: item.rombel,
          });
        });
      });
    },
    handleChange(val) {
      this.$emit("change", val);
    },
  },
};
</script>
